module.exports = __webpack_public_path__ + "static/img/model-bg36.3c9be3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg36.jpg
// module id = s6fO
// module chunks = 0